<app-dialog-banner [text]="title" [dialogRef]="dialogRef"></app-dialog-banner>

<div class="daily-time" [attr.data-form-ready]="ready ? 'true' : null">
    @if (ready) {
        <table>
            <thead>
                <tr>
                    <th class="omc" i18n>OMC</th>
                    @for (day of days; track $index) {
                        <th [matTooltip]="dayToolTip(day)">{{dayHeading(day)}}</th>
                    }
                    <th i18n>Total</th>
                </tr>
            </thead>
            <tbody>
                @for (omc of omcs; track omc.omcName) {
                    <tr>
                        <td class="omc">{{omc.omcName}}</td>
                        @for (minutes of omc.minutesByWeekday; track $index) {
                            <td>{{formatMinutes(minutes)}}</td>
                        }
                        <td class="total">{{formatMinutes(omc.total)}}</td>
                    </tr>
                } @empty {
                    <tr>
                        <td class="omc" colspan="9" i18n>No time recorded on actions completed in this week</td>
                    </tr>
                }
            </tbody>
            @if (omcs.length > 0) {
                <tfoot>
                    <tr>
                        <td class="omc" i18n>Total</td>
                        @for (minutes of dayTotals; track $index) {
                            <td>{{formatMinutes(minutes)}}</td>
                        }
                        <td class="total">{{formatMinutes(weekTotal)}}</td>
                    </tr>
                </tfoot>
            }
        </table>
        <div class="footer">
            <span class="note" i18n>Time is recorded on the day each action was completed</span>
            <button mat-button color="primary" data-view-actions (click)="viewActions()" i18n>View these actions</button>
        </div>

        <h4 class="activity-heading" i18n>Everything done this week</h4>
        <div class="activity-scroll">
            <table data-activity>
                <thead>
                    <tr>
                        <th class="omc" i18n>Item</th>
                        <th i18n>Created</th>
                        <th i18n>Updated</th>
                        <th i18n>Deleted</th>
                    </tr>
                </thead>
                <tbody>
                    @for (entry of activity; track entry.object + entry.model) {
                        <tr [class.parent]="!isLineItem(entry)" [class.line-item]="isLineItem(entry)">
                            <td class="omc">{{modelHeading(entry.model)}}</td>
                            <td>{{formatCount(entry.created)}}</td>
                            <td>{{formatCount(entry.updated)}}</td>
                            <td>{{formatCount(entry.deleted)}}</td>
                        </tr>
                    } @empty {
                        <tr>
                            <td class="omc" colspan="4" i18n>Nothing created, updated or deleted in this week</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }
</div>
